import {
	BulkSharePostOperationRequest,
	BulkSharePostRequest,
	ClientPostOperationRequest,
	ClientPostRequest,
	CorePluginApi,
	EvaluateExistingPost200Response,
	EvaluateExistingPostOperationRequest,
	EvaluateExistingPostRequest,
	EvaluatePostOperationRequest,
	EvaluatePostRequest,
	LinkManagementApi,
	LinksCreatePostOperationRequest,
	LinksCreatePostRequest,
	LinksDeleteOperationRequest,
	LinksDeleteRequest,
	LinkSettingsGetRequest,
	LinksGetRequest,
	LinksNotifyPostOperationRequest,
	LinksNotifyPostRequest,
	LinksPatchOperationRequest,
	LinksPatchRequest,
	LinksSearchPostOperationRequest,
	LinksSearchPostRequest,
	PermissionConfigurationPostOperationRequest,
	PermissionConfigurationPostRequest,
	PrincipalListUsersRequest,
	PrincipalManagementApi,
	PrincipalsListPostOperationRequest,
	PrincipalsListUsersPostRequest,
	ReplacePostOperationRequest,
	ReplacePostRequest,
	SharePostRequest,
	ShareRequest,
	UserManagementApi,
	UsersGetRequest,
} from '@sharefiledev/sharing-pilet-sdk/api';
import { permissionHttpConfiguration } from './PermissionHttpConfiguration';

const corePluginApi = new CorePluginApi(permissionHttpConfiguration);
const userApi = new UserManagementApi(permissionHttpConfiguration);
const principalApi = new PrincipalManagementApi(permissionHttpConfiguration);
const linkApi = new LinkManagementApi(permissionHttpConfiguration);
const xBffCsrf = 'true';

export const PermissionsHttp = {
	async evaluate(evaluatePostRequest: EvaluatePostRequest) {
		const request: EvaluatePostOperationRequest = {
			xBffCsrf,
			evaluatePostRequest,
		};
		return await corePluginApi.evaluatePost(request);
	},
	async evaluateExisting(evaluateExistingPostRequest: EvaluateExistingPostRequest) {
		const request: EvaluateExistingPostOperationRequest = {
			xBffCsrf,
			evaluateExistingPostRequest,
		};
		return await corePluginApi.evaluateExistingPost(request);
	},
	// This function is deprecated and will be removed in the future
	// Use evaluateExisting instead when support for user groups is added
	async evaluateExistingForUsers(
		evaluateExistingPostRequest: EvaluateExistingPostRequest
	) {
		const request: EvaluateExistingPostOperationRequest = {
			xBffCsrf,
			evaluateExistingPostRequest,
		};
		const response = await corePluginApi.evaluateExistingPost(request);
		return {
			grantedPermissions: response.grantedPermissions.filter(
				permission =>
					(permission.userId !== null &&
						permission.userId !== undefined &&
						permission.userId.trim() !== '') ||
					(permission.principalRID !== null &&
						permission.principalRID !== undefined &&
						permission.principalRID.trim() !== '')
			),
		} as EvaluateExistingPost200Response;
	},
	async getPermissionConfiguration(
		permissionConfigurationPostRequest: PermissionConfigurationPostRequest
	) {
		const request: PermissionConfigurationPostOperationRequest = {
			xBffCsrf,
			permissionConfigurationPostRequest,
		};
		return await corePluginApi.permissionConfigurationPost(request);
	},
	async share(shareRequest: ShareRequest) {
		const request: SharePostRequest = {
			xBffCsrf,
			shareRequest,
		};
		return await corePluginApi.sharePost(request);
	},
	async bulkShare(bulkSharePostRequest: BulkSharePostRequest) {
		const request: BulkSharePostOperationRequest = {
			xBffCsrf,
			bulkSharePostRequest,
		};
		return await corePluginApi.bulkSharePost(request);
	},
	async replace(replacePostRequest: ReplacePostRequest) {
		const request: ReplacePostOperationRequest = {
			xBffCsrf,
			replacePostRequest,
		};
		return await corePluginApi.replacePost(request);
	},
	async clientPost(clientPostRequest: ClientPostRequest) {
		const request: ClientPostOperationRequest = {
			xBffCsrf,
			clientPostRequest,
		};
		return await userApi.clientPost(request);
	},
	async getUsers(userIds: string[]) {
		const request: UsersGetRequest = {
			xBffCsrf,
			userId: userIds,
		};
		return await userApi.usersGet(request);
	},
	async getPrincipals(principalRIDs: string[]) {
		const request: PrincipalsListPostOperationRequest = {
			xBffCsrf,
			principalsListPostRequest: {
				principalRIDs,
			},
		};
		const response = await principalApi.principalsListPost(request);
		return response;
	},
	async getLink(linkSearchPostRequest: LinksSearchPostRequest) {
		const request: LinksSearchPostOperationRequest = {
			xBffCsrf,
			linksSearchPostRequest: linkSearchPostRequest,
		};
		return await linkApi.linksSearchPost(request);
	},
	async linkCreate(linkCreatePostRequest: LinksCreatePostRequest) {
		const request: LinksCreatePostOperationRequest = {
			xBffCsrf,
			linksCreatePostRequest: linkCreatePostRequest,
		};
		return await linkApi.linksCreatePost(request);
	},
	async linkNotify(linkNotifyPostRequest: LinksNotifyPostRequest) {
		const request: LinksNotifyPostOperationRequest = {
			xBffCsrf,
			linksNotifyPostRequest: linkNotifyPostRequest,
		};
		return await linkApi.linksNotifyPost(request);
	},
	async getLinkSettings(consumerPluginName?: string) {
		const request: LinkSettingsGetRequest = {
			xBffCsrf,
			consumerPluginName,
		};
		return await linkApi.linkSettingsGet(request);
	},
	async updateLinks(linksPatchRequest: LinksPatchRequest) {
		const request: LinksPatchOperationRequest = {
			xBffCsrf,
			linksPatchRequest,
		};
		return await linkApi.linksPatch(request);
	},
	async linkDelete(linksDeleteRequest: LinksDeleteRequest) {
		const request: LinksDeleteOperationRequest = {
			xBffCsrf,
			linksDeleteRequest,
		};
		return await linkApi.linksDelete(request);
	},
	async getLinkByLookUpKey(linkLookupKey: string) {
		const request: LinksGetRequest = {
			xBffCsrf,
			linkLookupKey,
		};
		return await linkApi.linksGet(request);
	},
	async getAuthorizedUsers(principalListUsersRequest: PrincipalListUsersRequest) {
		const request: PrincipalsListUsersPostRequest = {
			xBffCsrf,
			principalListUsersRequest,
		};
		return await principalApi.principalsListUsersPost(request);
	},
};
